import React from 'react';
import './ArticleHeading.scss';

interface Props {
    title: string;
    subtitle: string;
    date: string;
    listicle: boolean;
    category: string;
    HeroImage?: React.FC;
}

const Title = ({ title }: { title: string }) => {
    const titleParts = title.split(`**`);

    return (
        <h1>
            {titleParts.map((part, idx) => {
                if (idx % 2 === 0) {
                    return (
                        <React.Fragment key={`title-${idx}`}>
                            {part}
                        </React.Fragment>
                    );
                }
                return (
                    <span key={`title-${idx}`} className="accent">
                        {part}
                    </span>
                );
            })}
        </h1>
    );
};

export const ArticleHeading = ({
    title,
    subtitle,
    date,
    category,
    listicle,
    HeroImage,
}: Props) => {
    return (
        <header
            className={`dark article-header ${HeroImage ? `has-hero` : ``}`}
        >
            <div className="kite-container">
                <p className="eyebrow">
                    {category}
                    <span>|</span>
                    {date}
                </p>
                <Title title={title} />
                <p>{subtitle}</p>

                {HeroImage && <HeroImage />}
            </div>
        </header>
    );
};
